import { Controller } from "@hotwired/stimulus";
import axios from "axios";
import * as Sentry from "@sentry/browser";

export default class ProfessionalChooser extends Controller {
  initialize() {
    this.countryCode = this.data.get("countryCode");
    this.locale = this.data.get("locale");
    this.serviceIds = this.data.get("serviceIds");
    this.projectType = this.data.get("projectType");

    // fetch professionals by services
    this.getProfessionals();
  }

  async getProfessionals() {
    try {
      await axios({
        method: "get",
        url: `/${this.countryCode}/${this.locale}/p/by-services`,
        params: {
          "professional[service_ids]": JSON.parse(this.serviceIds),
          "professional[type]": this.projectType,
        },
        headers: {
          Accept: "text/vnd.turbo-stream.html, text/html, application/json",
        },
      }).then((response) => {
        // to render turbo response when use axios we have to call renderStreamMessage
        Turbo.renderStreamMessage(response.data);
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  }
}
